
export const patientDetails = {
  // title: {
  //   type: `select`,
  //   label: `Title`,
  //   labelHidden: true,
  //   placeholder: `Select title`,
  //   readonly: true,
  //   value: `Dr`,
  // items: [
  //   `Dr`,
  //   `Mr`,
  //   `Miss`,
  //   `Mrs`,
  //   `Ms`,
  // ],
  //   heading: {
  //     heading: `About`,
  //     level: `h5`,
  //   },
  // },
  first_name: {
    type: `text`,
    label: `First Name`,
    labelHidden: true,
    placeholder: `First Name`,
  },
  last_name: {
    type: `text`,
    label: `Last Name`,
    labelHidden: true,
    placeholder: `Last Name`,
  },
  email: {
    type: `text`,
    label: `Email Address`,
    labelHidden: true,
    placeholder: `Email Address`,
  },
};

export const dentistDetails = {
  first_name: {
    type: `text`,
    label: `First Name`,
    labelHidden: true,
    placeholder: `First Name`,
  },
  last_name: {
    type: `text`,
    label: `Last Name`,
    labelHidden: true,
    placeholder: `Last Name`,
  },
  email: {
    type: `text`,
    label: `Email Address`,
    labelHidden: true,
    placeholder: `Email Address`,
  },
  license_number: {
    type: `text`,
    labelHidden: true,
    label: `Dentist ID`,
    placeholder: `License Number`,
  },
  phone_number: {
    type: `tel`,
    label: `Phone Number`,
    labelHidden: true,
    placeholder: `Main phone number`,
  },
  specialty: { // WHY: Spelling error consistent with backend
    type: `select`,
    label: `Select Speciality`,
    labelHidden: true,
    placeholder: `Select Speciality`,
    items: [],
  },
};

export const address = {
  address_1: {
    type: `text`,
    label: `Address Line One`,
    labelHidden: true,
    placeholder: `Address Line One`,
    heading: {
      heading: `Address Information`,
      level: `h5`,
    },
  },
  address_2: {
    type: `text`,
    label: `Address Line Two`,
    labelHidden: true,
    placeholder: `Address Line Two`,
  },
  city: {
    type: `text`,
    label: `City`,
    labelHidden: true,
    placeholder: `City`,
  },
  state: {
    type: `text`,
    label: `State`,
    labelHidden: true,
    placeholder: `State`,
  },
  zipcode: {
    type: `text`,
    label: `ZIP`,
    labelHidden: true,
    placeholder: `ZIP`,
  },
};

export const dentistLocation = {
  name: {
    type: `text`,
    label: `Clinic Name`,
    labelHidden: true,
    placeholder: `Clinic Name`,
    heading: {
      heading: `Clinic/Hospital/Practice Information`,
      level: `h5`,
    },
  },
  address_1: {
    type: `text`,
    label: `Address Line One`,
    labelHidden: true,
    placeholder: `Address Line One`,
  },
  address_2: {
    type: `text`,
    label: `Address Line Two`,
    labelHidden: true,
    placeholder: `Address Line Two`,
  },
  city: {
    type: `text`,
    label: `City`,
    labelHidden: true,
    placeholder: `City`,
  },
  state: {
    type: `text`,
    label: `State`,
    labelHidden: true,
    placeholder: `State`,
  },
  zipcode: {
    type: `text`,
    label: `ZIP`,
    labelHidden: true,
    placeholder: `ZIP`,
  },
};



// WEBPACK FOOTER //
// ./client/models/dashboard/userDetails.js